import React from 'react';

// Gasco Components
import { GascoButtonCustomEvent } from '@gasco/core';

// Styles
import './Button.css';

type ButtonGascoProps = {
  buttonType?: string;
  children?: React.ReactNode;
  className?: string;
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  disabled?: boolean;
  fill?: 'clear' | 'default' | 'outline' | 'solid';
  progress?: boolean;
  shape?: 'round';
  size?: 'default' | 'large' | 'small';
  strong?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (event: React.MouseEvent) => void;
  onGascoBlur?: (event: GascoButtonCustomEvent<void>) => void;
  onGascoFocus?: (event: GascoButtonCustomEvent<void>) => void;
};

const Button = (props: ButtonGascoProps) => {

  const handleGascoBlur = (event: GascoButtonCustomEvent<void>) => {
    if (props.onGascoBlur) {
      props.onGascoBlur(event);
    }
  }

  const handleGascoFocus = (event: GascoButtonCustomEvent<void>) => {
    if (props.onGascoFocus) {
      props.onGascoFocus(event);
    }
  }
  
  return (
    <gasco-button
      className={props.className || 'button__gasco'}
      color={props.color || 'primary'}
      disabled={props.disabled || false}
      size={props.size || 'default'}
      strong={props.strong || false}
      fill={props.fill || 'solid'}
      shape={props.shape || undefined}
      progress={props.progress || false}
      type={props.type || 'button'}
      buttonType={props.buttonType || 'button'}
      onClick={props.onClick}
      onGascoBlur={handleGascoBlur}
      onGascoFocus={handleGascoFocus}
    >
      {props.children}
    </gasco-button>
  )
}
export default Button